import { Button, Col, Form, notification, Switch, Row } from "antd"
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../../../app/store"
import { EditableList } from "../../../../../compnents/list/EditableList"
import { getFieldSettingList, saveFieldSettingList, restoreDefaultSetting } from "../FieldSettingSlice"
import { unwrapResult } from "@reduxjs/toolkit"
import { selectEdition, selectTenantCategory } from "../../../../../app/applicationSlice"
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import {
  DndContext,
  DragEndEvent,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import { restrictToVerticalAxis } from '@dnd-kit/modifiers'
import { CSS } from '@dnd-kit/utilities'

const BLFeildMap = {
  'HZSZ': [
    { key: 'name', label: '患者姓名', isRequired: true, order: 1, isNotModified: true, rid: 'name' },
    { key: 'sex', label: '性别', isRequired: true, order: 2, isNotModified: true, rid: 'sex' },
    { key: 'age', label: '年龄', isRequired: true, order: 3, isNotModified: true, rid: 'age' },
    { key: 'height', label: '身高', isRequired: false, order: 4, rid: 'height' },
    { key: 'weight', label: '体重', isRequired: false, order: 5, rid: 'weight' },
    { key: 'waistline', label: '腰围', isRequired: false, order: 6, rid: 'waistline' },
    { key: 'maritalStatus', label: '婚姻状况', isRequired: false, order: 7, rid: 'maritalStatus' },
    { key: 'emailAddress', label: '邮箱地址', isRequired: false, order: 8, rid: 'emailAddress' },
    { key: 'wechat', label: '微信号', isRequired: false, order: 9, rid: 'wechat' },
    { key: 'phone', label: '联系方式', isRequired: false, order: 10, rid: 'phone' },
    { key: 'idCardNumber', label: '身份证号', isRequired: false, order: 11, rid: 'idCardNumber' },
    { key: 'companyName', label: '工作单位', isRequired: false, order: 12, rid: 'companyName' },
    { key: 'area', label: '家庭地区', isRequired: false, order: 13, rid: 'area' },
    { key: 'address', label: '详细地址', isRequired: false, order: 14, rid: 'address' },
    { key: 'emergencyContactName', label: '紧急联系人', isRequired: false, order: 15, rid: 'emergencyContactName' },
    { key: 'emergencyContactPhone', label: '紧急联系方式', isRequired: false, order: 16, rid: 'emergencyContactPhone' },
    { key: 'patientSource', label: '患者来源', isRequired: false, order: 17, rid: 'patientSource' },
    { key: 'nativePlace', label: '籍贯', isRequired: false, order: 18, rid: 'nativePlace' },
    { key: 'nation', label: '民族', isRequired: false, order: 19, rid: 'nation' },
    { key: 'job', label: '职业', isRequired: false, order: 20, rid: 'job' }
  ],
  'KQHZSZ': [
    { key: 'name', label: '患者姓名', isRequired: true, order: 1, isNotModified: true, rid: 'patientName' },
    { key: 'sex', label: '性别', isRequired: true, order: 2, isNotModified: true, rid: 'sex' },
    { key: 'age', label: '年龄', isRequired: true, order: 3, isNotModified: true, rid: 'age' },
    { key: 'phone', label: '联系电话', isRequired: true, order: 4, rid: 'phone' },
    { key: 'idCardNumber', label: '身份证号', isRequired: false, order: 5, rid: 'idCardNumber' },
    { key: 'emergencyContactPhone', label: '紧急联系方式', isRequired: false, order: 6, rid: 'emergencyContactPhone' },
    { key: 'qq', label: 'QQ号', isRequired: false, order: 7, rid: 'qq' },
    { key: 'weChat', label: '微信', isRequired: false, order: 8, rid: 'weChat' },
    { key: 'mail', label: '邮箱', isRequired: false, order: 9, rid: 'mail' },
    { key: 'nativePlace', label: '籍贯', isRequired: false, order: 10, rid: 'nativePlace' },
    { key: 'nation', label: '民族', isRequired: false, order: 11, rid: 'nation' },
    { key: 'addressData', label: '家庭地区', isRequired: false, order: 12, rid: 'addressData' },
    { key: 'address', label: '详细地址', isRequired: false, order: 13, rid: 'address' },
    { key: 'maritalStatus', label: '婚姻状况', isRequired: false, order: 14, rid: 'maritalStatus' },
    { key: 'job', label: '职业', isRequired: false, order: 15, rid: 'job' },
    { key: 'companyName', label: '工作单位', isRequired: false, order: 16, rid: 'companyName' },
    { key: 'patientSource', label: '患者来源', isRequired: false, order: 17, rid: 'patientSource' },
    { key: 'groupId', label: '患者分组', isRequired: false, order: 18, rid: 'groupId' },
    { key: 'labelIdList', label: '患者标签', isRequired: false, order: 19, rid: 'labelIdList' },
    { key: 'star', label: '星级', isRequired: false, order: 20, rid: 'star' },
    { key: 'introducerType', label: '介绍人', isRequired: false, order: 21, rid: 'introducerType' },
    { key: 'counselor', label: '咨询师', isRequired: false, order: 22, rid: 'counselor' },
    { key: 'customerService', label: '专属客服', isRequired: false, order: 23, rid: 'customerService' },
    { key: 'pastMedicalHistory', label: '既往史', isRequired: false, order: 24, rid: 'pastMedicalHistory' },
    { key: 'allergyHistory', label: '过敏史', isRequired: false, order: 25, rid: 'allergyHistory' },
    { key: 'toothCleaningHabit', label: '洁牙习惯', isRequired: false, order: 26, rid: 'toothCleaningHabit' },
    { key: 'treatmentHistory', label: '就诊经历', isRequired: false, order: 27, rid: 'treatmentHistory' },
    { key: 'toothBrushing', label: '刷牙', isRequired: false, order: 28, rid: 'toothBrushing' },
    { key: 'smokeFrequency', label: '吸烟', isRequired: false, order: 29, rid: 'smokeFrequency' },
    { key: 'treatmentItem', label: '就诊项目', isRequired: false, order: 30, rid: 'treatmentItem' },
    { key: 'attendingDoctor', label: '主治医师', isRequired: false, order: 31, rid: 'attendingDoctor' },
    { key: 'remark', label: '备注', isRequired: false, order: 32, rid: 'remark' },
  ]
}

export const PatientSetting = (props: {
  selectedTab: any
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()
  const [form] = Form.useForm()

  const hisVersion = useSelector(selectEdition)

  const [buttonLoading, setButtonLoading] = useState(false)

  const [tableLoading, setTableLoading] = useState(false)

  const [selectedType, setSelectedType] = useState<string>(hisVersion == 1 ? 'KQHZSZ' : 'HZSZ')

  const [tips, setTips] = useState<string>('注：作用于新增患者、挂号、预约')

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  useEffect(() => {
    if (props?.selectedTab == 'A2') {
      getPage(selectedType)
    }
  }, [props?.selectedTab])


  // 恢复默认设置按钮点击事件

  const restoreDefaultSettingBtnClick = () => {
    dispatch(restoreDefaultSetting({
      configType: 1,
      functionType: 2,
      templateType: selectedType,
    }))
      .then(() => {
        getPage(selectedType)
      })
      .catch((err) => {
        setTableLoading(false)
      })
  }


  const getPage = (templateType: string) => {
    setTableLoading(true)
    dispatch(getFieldSettingList({
      functionType: 2,
      templateType: templateType || selectedType,
    }))
      .then(unwrapResult)
      .then((res) => {
        if (res.length === 0) {
          const feilds = BLFeildMap[templateType as keyof typeof BLFeildMap]
          setPage({
            total: feilds.length,
            items: feilds,
          })
          setTableLoading(false)
          return
        } else {
          // 从后端获取的字段数据
          const backendFields = res[0].fields

          const defaultFields = BLFeildMap[templateType as keyof typeof BLFeildMap]

          const mergedFields = backendFields?.map((field: any) => {
            const defaultField = defaultFields?.find((df: any) => df.key == field.key)
            return {
              ...field,
              key: defaultField?.key || field.key,
              rid: defaultField?.key || field.key, // 补充rid字段，作为拖拽唯一ID
              isRequired: Boolean(field.isRequired),
              order: field.order || 1,
            }
          })
          setPage({
            total: mergedFields?.length,
            items: mergedFields,
          })
          setTableLoading(false)
        }
      })
      .catch((err) => {
        setTableLoading(false)
      })
  }

  return (
    <div style={{ height: '100%' }}>
      {/* <div style={{ margin: '0 0 6px 0' }}>{tips}</div> */}
      <div style={{
        height: 'calc(100% - 60px)',
        borderRadius: '8px',
      }}>
        <Form
          style={{ height: '100%' }}
          form={form}
          autoComplete='off'
          onFinish={() => {
            setButtonLoading(true)
            dispatch(
              saveFieldSettingList({
                configType: 1,
                functionType: 2,
                templateType: selectedType,
                fields: page.items,
              })
            )
              .then(unwrapResult)
              .then((val) => {
                notification.success({
                  message: '设置成功',
                })
                form.resetFields()
                getPage(selectedType)
              })
              .finally(() => {
                setButtonLoading(false)
              })
          }}
        >
          <div style={{ height: 'calc(100%)', paddingBottom: '20px', overflowY: 'auto' }}>
            <Row>
              <Col span={18}>
                <EditableList
                  loading={tableLoading}
                  rowKey={(record: any) => record.rid} // 确保rowKey和拖拽ID一致
                  dataSource={page.items} // 替换page属性为标准dataSource（适配antd Table）
                  bordered={true}
                  pagination={false}
                  // scroll={{ y: 1000, x: '100%' }}
                  columns={[
                    {
                      title: '序号',
                      key: 'no',
                      align: 'center',
                      width: '5rem',
                      fixed: 'left',
                      render: (_1, _2, i) => `${i + 1}`,
                    },
                    {
                      title: '患者字段',
                      dataIndex: "label",
                      key: "label",
                      align: "left",
                      width: '24rem',
                      fixed: 'left',
                      render: function labelElement(_, t) {
                        return (
                          <>
                            <span>{t.label}</span>
                            {hisVersion == 1 ? '' :
                              // 身高、体重、腰围、邮箱地址、微信号、职业、婚姻状况
                              (t?.key == 'height' || t?.key == 'weight' || t?.key == 'waistline' || t?.key == 'emailAddress' || t?.key == 'wechat' || t?.key == 'job' || t?.key == 'maritalStatus' ?
                                <span style={{ color: '#999999', fontSize: '12px' }}>（只作用于新增/编辑患者）</span> : <></>)
                            }

                          </>
                        )
                      },
                    },
                    {
                      title: '是否必填',
                      dataIndex: "isRequired",
                      key: "isRequired",
                      align: "center",
                      width: '12rem',
                      fixed: 'right',
                      render: function action(_, t, index) {
                        return (
                          <Switch
                            checkedChildren='开启'
                            unCheckedChildren='关闭'
                            checked={t.isRequired}
                            disabled={t.isNotModified}
                            onChange={(checked) => {
                              if (t.isNotModified) {
                                return
                              }
                              const newItems = [...page.items]
                              newItems[index] = {
                                ...newItems[index],
                                isRequired: checked
                              }
                              setPage({ ...page, items: newItems })
                            }}
                          />
                        )
                      },
                    },
                  ]}
                />
              </Col>
            </Row>
          </div>
          <Row>
            <Col span={12}>
              <Button
                htmlType='button'
                onClick={() => {
                  restoreDefaultSettingBtnClick()
                }}
                style={{ float: 'right', marginRight: '10px' }}
              >
                恢复默认设置
              </Button>
            </Col>
            <Col span={12}>
              <Button
                loading={buttonLoading}
                type='primary'
                htmlType='submit'
                style={{ float: 'left' }}
              >
                保存
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  )
}